module.exports = __webpack_public_path__ + "img/manda_018.32d93f5c.png";